import React, { useState, useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    MODAL_TYPE_LOGGED_OUT,
    MODAL_TYPE_LIMITED_ACCESS
} from '../../../../services/modal/constants';

import { showModal } from '../../../../services/modal/actions';

import { isLimitedMember } from '../../../../services/authentication/selector';
import useCartController from '../../../../services/ebon/hooks/useCartController';

import EbonSelectorLeftContainer from './EbonSelectorLeftContainer';
import EbonSelectorRightContainer from './EbonSelectorRightContainer';
import { LoadingComponent } from '../../../loading/LoadingComponent';

import './EbonSelectorComponentStyle.scss';

const EbonSelectorComponent = ({
    partner,
    i18n,
    isAuthenticated,
    isLimited,
    fetching,
    ebonPaymentConfig,
    showModal
}) => {
    const {
        cart,
        handleItemChange,
        getCartTotal,
        addItemCart,
        getCartQuantity
    } = useCartController();

    const [cartStatusMessage, setCartStatusMessage] = useState('');
    const focusTimeoutRef = useRef();
    const statusTimeoutRef = useRef();

    // Annule les timers au démontage : le timer d'effacement du message (3s)
    // ferait sinon un setState sur un composant démonté.
    useEffect(
        () => () => {
            clearTimeout(focusTimeoutRef.current);
            clearTimeout(statusTimeoutRef.current);
        },
        []
    );

    const addItemCartWithStatus = useCallback((item) => {
        addItemCart(item);
        setCartStatusMessage(i18n.ADDED_TO_BASKET);
        clearTimeout(focusTimeoutRef.current);
        focusTimeoutRef.current = setTimeout(() => {
            const btn = document.querySelector(
                `button[data-facial-value="${item.facialValue}"]`
            );
            if (btn) btn.focus();
        }, 100);
        clearTimeout(statusTimeoutRef.current);
        statusTimeoutRef.current = setTimeout(() => setCartStatusMessage(''), 3000);
    }, [addItemCart, i18n.ADDED_TO_BASKET]);

    const cartTotalQuantity = getCartQuantity(cart);
    const basketLimit = ebonPaymentConfig && ebonPaymentConfig.basketLimit;
    const defaultBasketLimit = ebonPaymentConfig && ebonPaymentConfig.basketLimitDefault;
    const effectiveBasketLimit = basketLimit || defaultBasketLimit || undefined;

    const isBasketLimitReached = () => {
        return effectiveBasketLimit && cartTotalQuantity >= effectiveBasketLimit;
    };
    const getBasketLimitMessage = () => {
        if (basketLimit && cartTotalQuantity >= basketLimit) {
            return i18n.CAPPING_MESSAGE;
        }
        if (defaultBasketLimit && cartTotalQuantity >= defaultBasketLimit) {
            return i18n.DEFAULT_CAPPING_MESSAGE;
        }
        return undefined;
    };

    // non connecté → modale de connexion ; membre limité → modale d'information :
    // dans les deux cas l'achat de bons d'achat est bloqué
    const purchaseBlocked = !isAuthenticated || isLimited;

    const guardPurchaseClick = event => {
        if (!isAuthenticated) {
            event.preventDefault();
            showModal(MODAL_TYPE_LOGGED_OUT);
            return false;
        }
        if (isLimited) {
            event.preventDefault();
            showModal(MODAL_TYPE_LIMITED_ACCESS);
            return false;
        }
    };

    return (
        <div id="ebon-selector-container" className="container">
            {fetching && (
                <div className="loading-div">
                    <LoadingComponent />
                </div>
            )}

            {!fetching && (
                <React.Fragment>
                    <div aria-live="polite" aria-atomic="true" className="sr-only">
                        {cartStatusMessage && <p>{cartStatusMessage}</p>}
                    </div>
                    <EbonSelectorLeftContainer
                        partner={partner}
                        cart={cart}
                        addItemCart={addItemCartWithStatus}
                        cartTotalQuantity={cartTotalQuantity}
                        basketLimit={effectiveBasketLimit}
                        isBasketLimitReached={isBasketLimitReached}
                        getBasketLimitMessage={getBasketLimitMessage}
                    />
                    <EbonSelectorRightContainer
                        partner={partner}
                        cart={cart}
                        handleItemChange={handleItemChange}
                        getCartTotal={getCartTotal}
                        isBasketLimitReached={isBasketLimitReached}
                        loginRequired={!isAuthenticated}
                        purchaseBlocked={purchaseBlocked}
                        guardPurchaseClick={guardPurchaseClick}
                    />
                </React.Fragment>
            )}
        </div>
    );
};

EbonSelectorComponent.propTypes = {
    partner: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.MERCHANTCARD.EBON_SELECTOR,
        isAuthenticated: state.authentication.isAuthenticated,
        isLimited: isLimitedMember(state),
        fetching: state.ebon.ebonsFetching,
        ebonPaymentConfig: state.ebon.ebons.ebonPaymentConfig
    };
};

const mapDispatchToProps = {
    showModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EbonSelectorComponent));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/ebonselector/EbonSelectorComponent.js